import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropTillagesByPrimaryDataId, getFootprintingCropTillagesByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_TILLAGES } from "consts";

export const useGetFootprintingCropTillagesByPrimaryDataId = (primaryDataId?: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFootprintingCropTillagesByPrimaryDataIdAdmin : getFootprintingCropTillagesByPrimaryDataId;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP_TILLAGES, primaryDataId, isAdmin],
      queryFn: () => queryFn(primaryDataId ?? ""),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
